<template>
  <el-input
    v-model="val"
    class="tags-input"
    size="normal"
    @keydown.native="tagInputKeyDown"
  >
    <div v-if="tags && tags.length" slot="prepend" class="h-full flex items-center">
      <el-tag
        v-for="(tag, i) in tags"
        :key="i"
        color="#5c6bc0"
        class="mx-1"
        size="small"
        effect="dark"
        type="info"
        closable
        @close="removeTag(tag, i)"
      >{{ tag }}</el-tag>

    </div>
  </el-input>
</template>

<script>
export default {
  model: {
    prop: 'value',
    event: 'change'
  },

  props: {
    value: {
      type: Array,
      default() {
        return []
      }
    }
  },

  data() {
    return {
      val: '',
      tags: []
    }
  },

  watch: {
    value: {
      handler(val) {
        this.tags = [...val]
      },
      immediate: true
    }
  },

  methods: {
    addTag() {
      this.tags.push(this.val)
      this.val = ''

      this.$emit('change', this.tags)
    },

    tagInputKeyDown(e) {
      // console.log(e)
      if (e.key === 'Enter') {
        this.addTag()
      } else if (e.key === 'Backspace' && !this.val) {
        this.tags.pop()
      }
    },

    removeTag(tag, i) {
      this.tags.splice(i, 1)
      this.$emit('change', this.tags)
    }
  }
}
</script>

<style lang="scss" scoped>
.tag-item {
  background-color: #5c6bc0;
  color: #fff;
}
</style>
